export default {"src":"/hedera/_next/static/media/lineLight.bfbd71f2.svg","height":2,"width":24};